import PropTypes from "prop-types";
import styled from "styled-components";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEdit} from "@fortawesome/free-solid-svg-icons";

// Components
import Accordion from "../../components/Accordion";
import Help from "../../components/Help";
import VisibilityConflictWarning from "./VisibilityConflictWarning";

// Style
import {z} from "../../style/components/mixins";
import {border, pad, radius} from "../../style/components/variables";
import {Abbr, Text} from "../../style/components/general";

const MemberRestrict = ({restrictTo = [], external = false, showModalEdit, conflicts = []}) => (
  <Menu>
    <Edit
      type="button"
      onClick={e => {
        e.stopPropagation();
        showModalEdit(true);
      }}>
      <Abbr title="Edit">
        <FontAwesomeIcon icon={faEdit} />
      </Abbr>
    </Edit>
    <Accordion
      arrowRight
      wrap
      compact
      testId="checksheet.visibilityAccordion"
      label={
        <>
          Checksheet Visibility Restriction&nbsp;
          <Help title="Restrict checksheet visibility">
            Limits who can see this checksheet at all &ndash; only the listed users or roles (and
            admins) will see it on the Records tab. Leave unrestricted to keep it visible to everyone
            with access to the facility.
          </Help>
        </>
      }>
      <Wrapper>
        {restrictTo?.length > 0 ? (
          <>
            <Text quiet>
              <strong>Restricted to {restrictTo[0].publicId ? "users" : "roles"}:</strong>{" "}
              {restrictTo
                .map(({label, firstName, lastName}) =>
                  firstName ? `${firstName} ${lastName}` : label
                )
                .join(", ")}
            </Text>
            {external && (
              <ExternalText quiet>
                <strong>Available via email only</strong>
              </ExternalText>
            )}
          </>
        ) : (
          <Text quiet>No restriction set.</Text>
        )}
      </Wrapper>
    </Accordion>
    <VisibilityConflictWarning conflicts={conflicts} />
  </Menu>
);

MemberRestrict.propTypes = {
  restrictTo: PropTypes.arrayOf(PropTypes.any),
  external: PropTypes.bool,
  showModalEdit: PropTypes.func.isRequired,
  conflicts: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string))
};

// Style Overrides
const Menu = styled.div`
  position: relative;
  border: ${border} solid ${({theme}) => theme.secondary};
  border-radius: ${radius};
  width: 100%;
  padding: ${pad}px;
  margin-bottom: ${pad}px;

  fieldset {
    padding-right: ${pad * 2}px;
  }
`;

const Wrapper = styled.div`
  margin-top: ${pad}px;
`;

const Edit = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  z-index: ${z("above")};
  padding: ${pad}px;
  width: min-content;

  svg {
    fill: ${({theme}) => theme.secondary};
  }
`;

const ExternalText = styled(Text)`
  margin-top: ${pad}px;
`;

export default MemberRestrict;
